import JSZip from 'jszip';

function getMimeType(extension) {
  switch (extension) {
    // Image formats
    case 'png': return 'image/png';
    case 'jpg':
    case 'jpeg': return 'image/jpeg';
    case 'gif': return 'image/gif';
    case 'bmp': return 'image/bmp';
    case 'webp': return 'image/webp';
    case 'tiff': return 'image/tiff';

    // Document formats
    case 'pptx': return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    case 'pdf': return 'application/pdf';

    // Video formats
    case 'mp4': return 'video/mp4';
    case 'mkv': return 'video/x-matroska';
    case 'avi': return 'video/x-msvideo';
    case 'mov': return 'video/quicktime';
    case 'wmv': return 'video/x-ms-wmv';
    case 'flv': return 'video/x-flv';
    case 'webm': return 'video/webm';
    case 'mpeg': return 'video/mpeg';

    default: return 'application/octet-stream'; // default to binary data
  }
}

export default async function zipDecompress(file, allowedExtensions = []) {
  // Create a new instance of JSZip
  const zip = new JSZip();

  // Load the ZIP file
  const zipContent = await zip.loadAsync(file);

  // Create an array of promises for the files in the ZIP
  const filePromises = [];

  zipContent.forEach((relativePath, zipEntry) => {
    // Skip folders and macOS metadata files
    if (zipEntry.dir || zipEntry.name.startsWith('__MACOSX/') || zipEntry.name.startsWith('._')) {
      return;
    }

    // Get the file extension
    const extension = zipEntry.name.split('.').pop();
    // Check if the file extension is allowed
    if (allowedExtensions.length > 0 && !allowedExtensions.includes(extension)) {
      throw new Error(`File with disallowed extension found [${zipEntry.name}]. Allowed extensions are: [${allowedExtensions.join(', ')}]`);
    }

    // Create a promise for the file
    const filePromise = zipEntry.async('blob').then(blob => new File([blob], zipEntry.name, { type: getMimeType(extension) }));

    // Add the promise to the array
    filePromises.push(filePromise);
  });

  // Wait for all file promises to resolve and return the resulting files
  return Promise.all(filePromises);
}
